module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.isMobile() ? 'modal--small' : 'modal--medium',
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-bottom": "10px",
      "cursor": "pointer"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.showImage = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit_picture')))])]), _vm._v(" "), _c('div', {
    staticClass: "mimage"
  }, [(_vm.showImage) ? _c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-bottom": "10px",
      "cursor": "pointer"
    }
  }, [(_vm.showImage === false) ? _c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n          " + _vm._s(_vm.locale.t('label_load_image')) + " ( "), _c('b', [_vm._v("max 5MB")]), _vm._v(") "), _c('i', {
    staticClass: "ti-upload"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.selectedImage != null) ? _c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.selectedImagePreview != null) ? _c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": _vm.selectedImagePreview
    }
  }) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.showImage === false && _vm.selectedImage != null) ? _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('div', {
    staticClass: "foo"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.uploadImage()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n         ")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e82b50c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ShowImageModal.vue
// module id = 808
// module chunks = 0